import React, {useContext, useEffect, useState} from "react";

import './ReportToUserModal.scss'
import authContext from "../../Auth/AuthContext";
import {ADD, useToastContext} from "../../Toast";
import {useRecoilState, useRecoilValue} from "recoil";
import {
  reportToUserModalOpenState,
  selectedAlarmState
} from "../../../state/alerts_table";
import {grpcNotificationServiceSelector, grpcUserServiceSelector} from "../../../state/grpc";
import {Form, Modal, Select, SelectItem, TextArea, InlineNotification} from "@carbon/react";
import SelectSkeleton from "@carbon/react/lib/components/Select/Select.Skeleton";

const ReportToUserModal = () => {
  const authCtx = useContext(authContext)
  const [recipientUsername, setRecipientUsername] = useState(null)
  const [messageContent, setMessageContent] = useState("")
  const {toastDispatch} = useToastContext();
  const selectedAlarm = useRecoilValue(selectedAlarmState)
  const [reportToUserModalOpen, setReportToUserModalOpen] = useRecoilState(reportToUserModalOpenState)
  const notificationService = useRecoilValue(grpcNotificationServiceSelector)
  const userService = useRecoilValue(grpcUserServiceSelector)
  const [loadingUsers, setLoadingUsers] = useState(true)
  const [users, setUsers] = useState([])
  const [formValid, setFormValid] = useState(true)

  useEffect(() => {
    if (!reportToUserModalOpen) {
      return
    }
    const req = new proto.api.ListUsersRequest()
    userService.listUsers(req, null, (err, resp) => {
      if (err != null) {
        console.error(err)
      } else {
        setUsers(resp.toObject().usersList)
      }
      setLoadingUsers(false)
    })
  }, [reportToUserModalOpen])

  return (
    <Modal
      open={reportToUserModalOpen}
      modalHeading="Invia messaggio ad operatore"
      modalLabel="Dati allarme"
      primaryButtonText="Invia"
      secondaryButtonText="Annulla"
      onRequestSubmit={(ev) => {
        if (recipientUsername == null || recipientUsername.length === 0 || messageContent == null || messageContent.length === 0) {
          setFormValid(false)
          ev.stopPropagation()
          return
        }
        setFormValid(true)
        const req = new proto.api.SaveNotificationRequest()
        const notReq = new proto.api.Notification()
        notReq.setSender(authCtx.data().username)
        notReq.setUsername(recipientUsername)
        notReq.setContent(messageContent)
        notReq.setActiontype("alarms")
        notReq.setActionrefid(selectedAlarm.id)
        req.setNotification(notReq)
        notificationService.createNotification(req, null, (err, resp) => {
          if (err != null) {
            console.log(err)
            toastDispatch({
              type: ADD,
              payload: {
                title: "Operazione fallita",
                content: "Impossibile inviare messaggio. Riprova più tardi",
                kind: "error",
                caption: err.message
              }
            })
          } else {
            toastDispatch({
              type: ADD,
              payload: {
                title: "Successo",
                content: "Messaggio inviato a " + recipientUsername + "!",
                kind: "success"
              }
            })
            setReportToUserModalOpen(false)
          }
        })
      }}
      onRequestClose={() => {
        setReportToUserModalOpen(false)
      }}>
      <p style={{marginBottom: 'rem'}}>
        Tramite questa modale ti è possibile inviare un messaggio ad un qualsiasi operatore abilitato, che riceverà
        immediatamente notifica del messaggio recapitato con la possibilità di leggere il testo specificato e di
        accedere
        e visualizzare l'allarme associato.
      </p>
      <br/>
      <Form>
        <TextArea
          data-modal-primary-focus
          maxCount={1000}
          value={messageContent}
          required={true}
          onChange={ev => {
            setMessageContent(ev.target.value)
          }}
          id="message-content"
          labelText="Testo del messaggio"
          style={{marginBottom: '1rem'}}
        />
        {
          loadingUsers && <SelectSkeleton/>
        }
        {
          !loadingUsers &&
          <Select
            id="message-recipient"
            defaultValue="placeholder-item"
            labelText="Seleziona un operatore"
            required={true}
            style={{marginBottom: '1rem'}}
            onChange={(ev) => setRecipientUsername(ev.target.value)}>
            <SelectItem
              disabled
              hidden
              value="placeholder-item"
              text="Seleziona un operatore"
            />
            {
              users.filter(it => it.username !== authCtx.data().username).map((it) =>
                <SelectItem
                  key={it.username}
                  value={it.username}
                  text={it.username}
                />
              )
            }
          </Select>
        }
      </Form>
      {
        !formValid &&
        <InlineNotification
          aria-label="Cancella notifica"
          onClose={function noRefCheck(){}}
          onCloseButtonClick={function noRefCheck(){}}
          statusIconDescription="notifica"
          subtitle="Devi compilare tutti i campi per inviare il messaggio"
          title="Validazione fallita"
        />
      }
    </Modal>
  )
}

export default ReportToUserModal